import { render, staticRenderFns } from "./staticData.vue?vue&type=template&id=3c18ea5a&scoped=true&"
import script from "./staticData.vue?vue&type=script&lang=js&"
export * from "./staticData.vue?vue&type=script&lang=js&"
import style0 from "./staticData.vue?vue&type=style&index=0&id=3c18ea5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18ea5a",
  null
  
)

export default component.exports